export default __webpack_public_path__ + "locales/pt/ChangeUserTypeDialog.json?hash=70e105308f6c9905a2ddf81ffcd746f5";